// ABOUTME: The keyframes of the eight weather vignettes, copied from the weather response reference.
// ABOUTME: Names match the reference's wr* keyframes so a change there maps one to one.

import { keyframes, type Keyframes } from '@emotion/react';

// v28's wxSceneIn: the scene layer's entrance and the scene title's fade-in both end at full opacity.
export const SCENE_IN = keyframes`
  to { opacity: 1; }
`;

export const WEATHER_KEYFRAMES: Record<string, Keyframes> = {
  wrCloudGrow: keyframes`
    0%,12% { transform: scale(0.3) translateY(14px); opacity: 0; }
    26% { opacity: 0.9; }
    62% { transform: scale(1) translateY(0); opacity: 0.95; }
    82% { transform: scale(1.12) translateY(-4px); opacity: 0.9; }
    96%,100% { transform: scale(1.12) translateY(-4px); opacity: 0; }
  `,
  wrPullBack: keyframes`
    0%,30% { transform: translateX(0) rotate(0deg); }
    52% { transform: translateX(26px) rotate(3deg); }
    66% { transform: translateX(26px) rotate(3deg); }
    86%,100% { transform: translateX(0) rotate(0deg); }
  `,
  wrLock: keyframes`
    0%,16% { opacity: 0.25; transform: scaleX(0.6); }
    40% { opacity: 0.95; transform: scaleX(1); }
    84% { opacity: 1; transform: scaleX(1.04); }
    100% { opacity: 0.25; transform: scaleX(0.6); }
  `,
  wrStreak: keyframes`
    0% { transform: translateY(0); opacity: 0; }
    22% { opacity: 0.7; }
    78% { transform: translateY(66px); opacity: 0.55; }
    100% { transform: translateY(80px); opacity: 0; }
  `,
  wrOpenSide: keyframes`
    0%,34% { opacity: 0; transform: translateX(16px); }
    54% { opacity: 0.7; transform: translateX(0); }
    76% { opacity: 0.45; }
    100% { opacity: 0.12; transform: translateX(10px); }
  `,
  wrCellA: keyframes`
    0%,10% { opacity: 0.16; }
    26% { opacity: 1; }
    44% { opacity: 0.4; }
    68% { opacity: 0.95; }
    88%,100% { opacity: 0.4; }
  `,
  wrCellB: keyframes`
    0%,22% { opacity: 0.16; }
    40% { opacity: 1; }
    58% { opacity: 0.4; }
    82% { opacity: 0.9; }
    96%,100% { opacity: 0.4; }
  `,
  wrCellC: keyframes`
    0%,26% { opacity: 0.3; transform: scale(0.9); }
    40% { opacity: 1; transform: scale(1.06); }
    54% { opacity: 0.35; transform: scale(0.94); }
    82% { opacity: 1; transform: scale(1.06); }
    94%,100% { opacity: 0.35; transform: scale(0.94); }
  `,
  wrScanBand: keyframes`
    0%,5% { opacity: 0; transform: rotate(-34deg); }
    11% { opacity: 0.9; transform: rotate(-34deg); }
    30% { transform: rotate(-34deg); }
    38% { transform: rotate(0deg); }
    58% { transform: rotate(0deg); }
    66% { transform: rotate(32deg); }
    92% { opacity: 0.9; transform: rotate(32deg); }
    100% { opacity: 0; transform: rotate(32deg); }
  `,
  wrFarSquall: keyframes`
    0%,10% { opacity: 0; transform: translateX(0); }
    26% { opacity: 0.9; }
    60% { opacity: 0.88; transform: translateX(-70px); }
    84% { opacity: 0.9; transform: translateX(-118px); }
    94% { opacity: 0.9; transform: translateX(-118px); }
    100% { opacity: 0; transform: translateX(-118px); }
  `,
  wrMirrorForm: keyframes`
    0%,24% { opacity: 0; transform: scale(0.45); }
    54% { opacity: 0.92; transform: scale(1); }
    93% { opacity: 0.92; transform: scale(1.02); }
    100% { opacity: 0; transform: scale(0.96); }
  `,
  wrHeldCloud: keyframes`
    0%,14% { opacity: 0; transform: scale(0.4); }
    42% { opacity: 0.95; transform: scale(1.06); }
    56% { transform: scale(1.06); }
    68%,88% { opacity: 0.95; transform: scale(0.82); }
    100% { opacity: 0.4; transform: scale(0.78); }
  `,
  wrHeldBox: keyframes`
    0%,48% { opacity: 0; transform: scale(1.3); }
    62% { opacity: 1; transform: scale(1); }
    90% { opacity: 1; transform: scale(1); }
    100% { opacity: 0.4; transform: scale(1); }
  `,
  wrAnchorRope: keyframes`
    0%,14% { height: 0px; }
    44% { height: 62px; }
    100% { height: 62px; }
  `,
  wrAnchorSink: keyframes`
    0%,10% { transform: translateY(-8px); opacity: 0; }
    16% { opacity: 1; }
    44% { transform: translateY(54px); opacity: 1; }
    96% { transform: translateY(54px); opacity: 1; }
    100% { transform: translateY(54px); opacity: 0.5; }
  `,
  wrLandmarkFade: keyframes`
    0%,26% { opacity: 0.9; }
    58% { opacity: 0.22; }
    80% { opacity: 0.18; }
    100% { opacity: 0.9; }
  `,
  wrFogBank: keyframes`
    0%,10% { transform: translateX(268px); opacity: 0; }
    30% { opacity: 0.5; }
    58% { transform: translateX(10px); opacity: 0.88; }
    80% { transform: translateX(-16px); opacity: 0.88; }
    94%,100% { transform: translateX(-44px); opacity: 0; }
  `,
  wrTurnTo: keyframes`
    0%,30% { transform: translateX(0); }
    58% { transform: translateX(-34px); }
    88% { transform: translateX(-34px); }
    100% { transform: translateX(0); }
  `,
  wrFrontEdge: keyframes`
    0%,26% { transform: translateX(0); opacity: 0.9; }
    56% { transform: translateX(-92px); opacity: 0.75; }
    86% { transform: translateX(-116px); opacity: 0.6; }
    100% { transform: translateX(0); opacity: 0.9; }
  `,
  wrSunOpen: keyframes`
    0%,24% { opacity: 0; transform: scale(0.5); }
    46% { opacity: 0.95; transform: scale(1); }
    88% { opacity: 0.95; transform: scale(1.04); }
    100% { opacity: 0; transform: scale(1.04); }
  `,
};
